import { HOST } from "./../global";

export function buildParams(paramObj: any) {
  return Object.keys(paramObj)
    .map((k) => {
      return `${k}=${paramObj[k]}`;
    })
    .join("&");
}

export function globalToLocalURL(url: string) {
  return url.replace(HOST, "");
}

export function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function URLJoin(urls: Array<string>) {
  const processed = urls.map((url: string) => {
    if (url.length <= 1) {
      return url;
    } else {
      if (url.slice(-1) == "/") {
        return url.slice(0, -1);
      } else {
          return url;
      }
    }
  });
  return processed.join("/");
}
